import * as React from "react";
function SvgArrowUp(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        d="M16 28V6m9 8l-9-9-9 9"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgArrowUp);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
